import React from "react";

const Installed = () => {
  return <div>Installed</div>;
};

export default Installed;
